import React, {type ReactNode} from 'react';
import {useIntl} from 'react-intl';

import {isErrorInvalidSlashCommand, isNotAvailableServerError, isPluginSlashCommandError} from 'utils/post_utils';

import {TextboxError} from 'components/textbox/textbox_error';

import {type ServerError} from 'mattermost-redux/types/errors';

type MessageSubmitErrorProps = {
    error: ServerError | Error | null;
    handleSubmit: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
    submittedMessage?: string;
}

export const MessageSubmitError = (props: MessageSubmitErrorProps) => {
    const {formatMessage} = useIntl();

    const renderSlashCommandError = (error: ServerError) => {
        if (!props.submittedMessage) {
            return error.message;
        }

        const [command] = props.submittedMessage.split(' ');
        return (
            <>
                {formatMessage({
                    id: 'message_submit_error.invalidCommand',
                    defaultMessage: "Couldn't find the command «{command}». ",
                }, {command})}
                <a
                    href='#'
                    onClick={props.handleSubmit}
                >
                    {formatMessage({
                        id: 'message_submit_error.sendAsMessageLink',
                        defaultMessage: 'Click here to send as a message',

                    })}
                </a>
            </>
        );
    };

    const renderPluginSlashCommandError = (error: ServerError) => {
        if (!props.submittedMessage) {
            return error.message;
        }

        const [command] = props.submittedMessage.split(' ');
        const pluginName = command?.slice(1);
        return formatMessage({
            id: `message_submit_error.plugin.${pluginName}.permission`,
            defaultMessage: 'Plugin "{pluginName}" is disabled by the channel administrator.',
        }, {pluginName});
    };

    const error = props.error;
    const command = props.submittedMessage?.split(' ')[0];

    if (!error) {
        return null;
    }

    let errorContent: ReactNode = error.message;
    if (isErrorInvalidSlashCommand(error)) {
        errorContent = renderSlashCommandError(error);
    }

    if (command && isPluginSlashCommandError(error)) {
        errorContent = renderPluginSlashCommandError(error);
    }

    if (isNotAvailableServerError(error)) {
        errorContent = formatMessage({
            id: 'message_autocomplete_error.notAvailable',
            defaultMessage: 'The commands are not available yet — try again later.',
        });
    }

    return (
        <TextboxError error={errorContent} />
    );
};

